export default "__VITE_ASSET__m48xwea___"